//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { LABEL_MARKS } from './RequestWorkTypes.js'

export default {
  name: 'RequestTechnologicalOperationListElement',
  components: {
  },
  props: {
    technologicalOperation: {
      type: Object,
      required: true
    },
    request: {
      type: Object,
      required: true
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      technologicalOperationLocal: JSON.parse(JSON.stringify(this.technologicalOperation)),
      technologicalOperationMark: LABEL_MARKS.technologicalOperation
    }
  },
  watch: {
    technologicalOperation: {
      handler (newValue) {
        this.technologicalOperationLocal = JSON.parse(JSON.stringify(newValue))
      },
      deep: true
    }
  },
  methods: {
    onChangeTechnologicalOperation: function () {
      this.$emit('update-technological-operation', this.technologicalOperationLocal)
    },
    onInputRequired: function (value) {
      if (!value) {
        this.technologicalOperationLocal.resultsRequired = false
      }
      this.onChangeTechnologicalOperation()
    },
    onInputResultsRequired: function (value) {
      if (value) {
        this.technologicalOperationLocal.required = true
      }
      this.onChangeTechnologicalOperation()
    }
  }
}
